import { ChangeDetectorRef, Component, NgZone, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse  } from '@angular/common/http';
import { LocalStorageService } from 'ngx-webstorage';
import { FunctService } from '../../shared/services/funct.service';
import { catchError, retry } from 'rxjs/operators';
import { interval, Subscription, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { DtoService } from '../../shared/services/dto.service';
import { CommonService } from '../../shared/services/common.service';
import { MaintenanceService } from '../../shared/services/maintenance.service'
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AccountLoginComponent } from '../../shared/components/account-login/account-login.component';
import { NavigationService } from '../../shared/services/navigation.service';
import { AppBannerAdsComponent } from '../../shared/components/app-banner-ads/app-banner-ads.component';
import { OneSignal } from 'onesignal-ngx';
import * as moment from 'moment';
import { TelegramService } from '../../telegram-services';
import { DeviceUUID, Agent } from 'device-uuid';
import { UtilService } from '../../shared/services/util.service';
declare var gonative: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],

})
export class HomeComponent implements OnInit {

  @ViewChild(AccountLoginComponent) child: AccountLoginComponent;
  @ViewChild(AppBannerAdsComponent) child2: AppBannerAdsComponent;

  gameProviderList: any = [];
  localgameProviderList: any;
  deviceId: any;
  fcmToken: any;
  token: any;
  isUserLoggedIn: any;
  ipAddress: any;
  oneSignalUserId: any;
  isMaintenance: boolean;
  currentTime: any;
  isTelegramLoggingIn = false;
  private subscription: Subscription;
  loadingLogin: boolean = false;
  isLoginChecked = false;

  
  constructor(
    private cdr: ChangeDetectorRef,
    private oneSignal: OneSignal,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private router: Router,
    private dto: DtoService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    private storage: LocalStorageService,
    private funct: FunctService,
    public common: CommonService,
    public maintenance: MaintenanceService,
    public navigation: NavigationService,
    private telegramService: TelegramService,
    private util: UtilService, 
    private ngZone: NgZone
  ) { 
    
    this.storage.clear('localGameType');
    this.storage.clear(`localGameList${this.storage.retrieve('localGameProviderId')}`);
    this.storage.clear('localGameProviderId');
    this.storage.clear('localLaunchGameObj');
    this.storage.clear('localCloseGameBalance');
    this.storage.clear('localCountryBlackList');
    this.storage.clear("newuserchoosesms"); //add this
    this.storage.clear("localNewlyRegister");//add this
    this.storage.clear("lemail");
    //Added these
    this.storage.clear('actionType');
    //this.storage.clear('actionType1');
    //this.storage.clear('localsmstype');
    this.storage.clear('loccaltype');
    //localStorage.removeItem('time');
    //this.storage.clear('localOtpSms');
    this.storage.clear('localPhoneNumber');
    //Clear type
    this.fcmToken = this.route.snapshot.paramMap.get("fcmToken");
    if (this.fcmToken != null) {
      this.storage.store('localFcmtoken', this.fcmToken);
      this.updateFCMtoken(this.fcmToken)
    }
   
  }
 
  async ngOnInit(): Promise<void> {
    await this.checkTelegramLogin();
    
    this.isUserLoggedIn = await this.storage.retrieve('isUserLoggedIn');
    this.isLoginChecked = true;
    if(this.isUserLoggedIn) this.updateUsedTime();
    
    this.getGameProviderList();
    this.oneSignal.init({
   // appId: "041ae446-0d6d-4989-b5ca-03a2977787d1", // prod app.shwetiger.com
   //  appId: "dda3887d-c785-4b2c-a48d-ecc263c8ff76", // prod shwetigerapp.com
     appId: "12a381d6-6580-4f46-b9c9-9e27c6787aa1", // testing app.gbost11.com
    });
  
    this.onHandleTag("Web");
    this.updatePlayerIdMobile();   

    // const newTime = new Date()
    // this.currentTime = moment(newTime, 'hh:mm')
   //Test call close
   this.closeMaintenanceBox();
   //Call
   this.getSMSOperators();
   this.getSetting();
  }
  //Telegram section
  async checkTelegramLoginV1() {
  const tg = (window as any).Telegram?.WebApp;

  if (!tg?.initData) {
    return; // not opened inside Telegram
  }

  tg.ready();

  const currentTelegramId = tg.initDataUnsafe?.user?.id;

  // already logged user info
  const savedTelegramId = await this.storage.retrieve('telegram_id');
  const isLoggedIn = await this.storage.retrieve('isUserLoggedIn');

  // same user already logged in -> no need login again
  if (isLoggedIn && savedTelegramId == currentTelegramId)
    {
    //alert('Already logged in');
    return;
  }
 // Different Telegram account detected
  if(savedTelegramId && savedTelegramId != currentTelegramId)
    {
    console.log("User switched, clearing old data");
    await this.clearPreviousUser();
  }

  // different user or first login
  this.telegramLogin();
  }
  async checkTelegramLogin() {
    const tg = (window as any).Telegram?.WebApp;

    if (!tg) return;

    tg.ready();

    let retry = 0;
    while (!tg.initDataUnsafe?.user && retry < 10) {
      await new Promise(resolve => setTimeout(resolve, 300));
      retry++;
    }

    if (!tg.initDataUnsafe?.user) return;

    const currentTelegramId = tg.initDataUnsafe.user.id;

    const savedTelegramId = await this.storage.retrieve('telegram_id');
    const isLoggedIn = await this.storage.retrieve('isUserLoggedIn');

    if (isLoggedIn && savedTelegramId == currentTelegramId) {
      this.isUserLoggedIn = true;
      this.util.isLogged = true;
      return;
    }

    const loginSuccess = await this.telegramLogin();

    if (loginSuccess) {
      this.isUserLoggedIn = true;
      this.util.isLogged = true;

      this.cdr.detectChanges();
    }
  }
  async telegramLogin() {
    const tg = (window as any).Telegram?.WebApp;

    if (!tg?.initDataUnsafe?.user) return false;

    tg.ready();

    const user = tg.initDataUnsafe.user;

    const telegramLoginModel = {
      initData: tg.initData,
      telegram_id: user.id,
      username: user.username,
      first_name: user.first_name,
      app_version: "1.0.1"
    };

    this.spinner.show("loginLoading");

    return new Promise((resolve, reject) => {
      this.http.post(
        this.funct.ipaddress + 'tg/webappLogin',
        telegramLoginModel
      ).subscribe(
        async (result: any) => {

          this.spinner.hide("loginLoading");
          if (result.status !== 'Error' && result.token) {
            this.dto.token = "Bearer " + result.token;
            this.util.isLogged = true;
           
          this.ngZone.run(async () => {
            this.isUserLoggedIn = true;
            this.util.isLogged = true;

            await this.storage.store('token', this.dto.token);
            await this.storage.store('isUserLoggedIn', true);
            await this.storage.store('telegram_id', user.id);

            this.cdr.detectChanges();

            resolve(true);
          });
            resolve(true);
          } else {
            resolve(false);
          }
        },
        (error) => {
          this.spinner.hide("loginLoading");
          reject(error);
        }
      );
    });
  }
  telegramLoginV1() {
  const tg = (window as any).Telegram?.WebApp;

  tg.ready();

  const initData = tg.initData;
  const user = tg.initDataUnsafe?.user;

  let telegramLoginModel: any = {
    initData: initData,
    telegram_id: user?.id,
    username: user?.username,
    first_name: user?.first_name,
    app_version: "1.0.1"
  };


  this.http.post(
    this.funct.ipaddress + 'tg/webappLogin',
    telegramLoginModel
  ).subscribe(
    async (result: any) => {
      this.dto.Response = result;
      this.loadingLogin = false;
      this.spinner.hide("loginLoading");

      if (this.dto.Response.status != 'Error') {
        var token = result["token"];

        if (token != null) {
          this.util.isLogged = true;
          this.dto.token = "Bearer " + token;

          await this.storage.store('token', this.dto.token);
          await this.storage.store('isUserLoggedIn', true);

          sessionStorage.setItem('rootUrl', 'auto-login');
          //this.navigation.goBack();
          // store telegram user id
          await this.storage.store('telegram_id', user?.id);
          this.router.navigate(['/home']);
        }
      } else {
        alert(this.dto.Response.message);
      }
    },
    (error) => {
      this.loadingLogin = false;
      this.spinner.hide("loginLoading");

      alert("Error: " + JSON.stringify(error));

      // if backend sends message
      if (error.error?.message) {
        alert("Backend Error: " + error.error.message);
      }
    }
  );
}

  isTelegram()
  {
  const tg = (window as any).Telegram?.WebApp;
  return tg && tg.initData && tg.initData.length > 0;
  }
  async clearPreviousUser() {
  await this.storage.clear('token');
  await this.storage.clear('isUserLoggedIn');
  await this.storage.clear('telegram_id');
  sessionStorage.clear();
  this.util.isLogged = false;
  this.dto.token = null;
}
  //End of telegram
  getSetting()
  {
    this.token = this.storage.retrieve('token');
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', this.token);
    var phoneNo = this.storage.retrieve("localphonevalue");
    if(phoneNo != null)
    {
    this.http.get(this.funct.ipaddress + 'user/userSmsType?phone_no='+phoneNo, { headers: headers })
    .pipe(
      catchError(this.handleError.bind(this))
    )
    .subscribe(
      result => {
        this.dto.Response = {};
        this.dto.Response = result;
        var smsType = this.dto.Response.smstype;
        this.storage.store("localsmsType",smsType);
    });
   } 
  }
  async updatePlayerIdMobile() {
    if  (navigator.userAgent.indexOf('gonative') > -1) {

      let info = await gonative.onesignal.onesignalInfo();     
      this.oneSignalUserId = info.oneSignalUserId;   
      var phone_no = this.storage.retrieve('localPhoneValue');
      if ((this.oneSignalUserId != null && this.oneSignalUserId != "") && ( phone_no != null && phone_no != "")) {

        this.token = this.storage.retrieve('token');    
        let headers = new HttpHeaders();
        headers = headers.set('Authorization', this.token); 
      
        var updateProfileId = { "playerId": this.oneSignalUserId, "device": "mobile", "phone_no": phone_no };

        if (this.token != null && this.token != "" ) {
          
          this.http.post(this.funct.ipaddress + 'user/updatePlayerId', updateProfileId, { headers: headers })
          .pipe (
            catchError(this.handleError.bind(this))
          )
          .subscribe(
            result => {        
              this.dto.Response = result; 
          });

        } else {

          this.http.post(this.funct.ipaddress + 'user/updatePlayerId', updateProfileId)
          .pipe (
            catchError(this.handleError.bind(this))
          )
          .subscribe(
            result => {        
              this.dto.Response = result;    
          });

        }
        
      }
      
    }
  }
  onHandleTag(tag: string) {

    this.oneSignal.setSubscription(true);

    this.oneSignal.getUserId(e=> {

      var phone_no = this.storage.retrieve('localPhoneValue');
      if ((e != null && e != "") && ( phone_no != null && phone_no != "")) {
      
          this.token = this.storage.retrieve('token');    
          let headers = new HttpHeaders();
          headers = headers.set('Authorization', this.token);

          var updateProfileId = {
            "playerId": e,
            "device": "web",
            "phone_no": phone_no
          } 
          if (this.token !=null && this.token !="") {

            this.http.post(this.funct.ipaddress + 'user/updatePlayerId', updateProfileId, { headers: headers })
            .pipe (
              catchError(this.handleError.bind(this))
            )
            .subscribe(
              result => {        
                this.dto.Response = result;        
            });
      
          } else {

            this.http.post(this.funct.ipaddress + 'user/updatePlayerId', updateProfileId)
            .pipe (
              catchError(this.handleError.bind(this))
            )
            .subscribe(
              result => {        
                this.dto.Response = result;
              
            });

          }
      

      }
      
    });
    this.oneSignal.sendTag("tag",tag).then(()=> {
  
    });
  }
  handleError(error: HttpErrorResponse)
  {
    if (error.status == 0) {
      this.common.errorMsg("", "checkInternet", "top");
      return;

    } else if (error.status == 423) {
      this.common.errorMsg("", "youNeedLogin", "top");
      this.storage.store('token','');
      this.storage.store('isUserLoggedIn', false);
      return;

    } else if (error.status == 400) {
      this.common.errorMsg("", "bad_request", "top");
      return;

    }
  }

  getGameProviderList() {
   
    let headers = new HttpHeaders(); 
    
    this.http.get(this.funct.ipaddress + 'gameProvider/getGameProviderList', { headers: headers })
    .pipe(
      catchError(this.handleError.bind(this))
    )
    .subscribe(
      result => {
        this.dto.Response = {};
        this.dto.Response = result;
        this.gameProviderList = [];
        this.storage.store('localGameProviderList', this.dto.Response);
        this.gameProviderList = this.dto.Response;
        // if (this.dto.Response.length > 0) {
        //   this.dto.Response.map((game: any, index: number) => {
        //     if(game.isMaintenance) {
        //        window.alert("is maintenance");
        //       this.getMaintenanceTime(game)
        //     }
        //     this.gameProviderList.push(game)
        //   })
        // }
    });
  }

  twodPage() {
    if (this.isUserLoggedIn) 
    {
        this.router.navigate(['/twod'], { replaceUrl: false });
     }
    else
      {      
      this.storage.store('fromBtnClicked', true);
      this.router.navigate(['/auth/login'], { replaceUrl: false });
    }
  }

  threedPage() {
    if (this.isUserLoggedIn) this.router.navigate(['/threed'], { state: {parentLink: "/home"}, replaceUrl: false });
    else {
      this.storage.store('fromBtnClicked', true);
      this.router.navigate(['/auth/login'], { replaceUrl: false });
    }
  }

  needHelpPage() {
    this.router.navigate(['/need-help'], { replaceUrl: true });
  }

  downloadPage() {
    this.router.navigate(['/download'], { state:{parentLink: "/home"}, replaceUrl: true });
  }

  goToGame(id, g_type) {
    if (this.isUserLoggedIn) {
      this.storage.store('localGameType', g_type);
      this.router.navigate(['/game/list',id], {state: { providerId: id, gameType: g_type, parentLink: ""}, replaceUrl: false });   
    } else {
      this.storage.store('fromBtnClicked', true);
      this.router.navigate(['/auth/login'], { replaceUrl: false });
    }
  }

  updateFCMtoken(token) {
    
    this.token = this.storage.retrieve('token');    
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', this.token); 
    var newToken = {
      fcmtoken: token
    } 
    this.http.post(this.funct.ipaddress + 'user/updateFcmtoken', newToken, { headers: headers })
    .pipe (
      catchError(this.handleError.bind(this))
    )
    .subscribe(
      result => {        
        this.dto.Response = result;  
    });

  }

  updateUsedTimeV1() {
    
    this.token = this.storage.retrieve('token');    
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', this.token);
    this.http.get(this.funct.ipaddress + 'Authenticate/updateUsedTime', { headers: headers })
    .pipe(
      catchError(this.handleError.bind(this))
    )
    .subscribe(
      result => {   
        this.dto.Response = result;
      }
    );

  }

  updateUsedTime() {

  this.token = this.storage.retrieve('token');


  let headers = new HttpHeaders();
  headers = headers.set('Authorization', this.token);

  this.http.get(
    this.funct.ipaddress + 'Authenticate/updateUsedTime',
    { headers: headers }
  )
  .pipe(
    catchError(this.handleError.bind(this))
  )
  .subscribe(
    result => {

      this.dto.Response = result;


    },
    error => {
    }
  );

}
  openTab(tabId) {

    var i, tabcontent, tablinks;
  
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
  
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
  
    const tabLink = document.querySelector(`[data-id="${tabId}"]`);
    tabLink.className += " active";

    document.getElementById(tabId).style.display = "block";
  }

  closeMaintenanceBox () {
    //this.subscription.unsubscribe();
    let headers = new HttpHeaders();
    this.http.get(this.funct.ipaddress + 'gameProvider/CloseMaintenance', { headers: headers })
    .pipe(
      catchError(this.handleError.bind(this))
    )
    .subscribe(
      result => {
        if (result.status === 'Success') {
          // this.refreshPage();
        }
    })
  }

  getTimeDifference (game: any, fromTime: any, toTime: any) {
    const newTime = new Date()
    const currentTime = moment()
    const timeLeft = moment.duration(toTime.diff(moment()));   

    if (timeLeft.isValid()) {
      game.startTime = true
    } else {
      game.startTime = false
      this.closeMaintenanceBox();
      this.subscription.unsubscribe();
    }
    

    if (timeLeft.seconds() < 0) {
      game.startTime = false
      this.closeMaintenanceBox();
    } 
  }

  getMaintenanceTime(gameAlertObject: any) {
    const toTime = moment(gameAlertObject.toTime, 'DD/MM/YYYY hh:mm')
    const fromTime = moment(gameAlertObject.fromTime, 'DD/MM/YYYY hh:mm')
    const newTime = new Date()
    const currentTime = moment(newTime, 'DD/MM/YYYY hh:mm')

    if (currentTime.isAfter(fromTime) && currentTime.isBefore(toTime)) {
      gameAlertObject.startTime = true
    }
    this.subscription = interval(1000)
      .subscribe(x => { 
        this.getTimeDifference(gameAlertObject, fromTime, toTime)
      });
  }

  notificationPage() {
    this.router.navigate(['/notification'],{replaceUrl: false} );
  }

  languagePage() {
    this.router.navigate(['/change-language'],{replaceUrl: false} );
  }

  refreshPage() {
    this.spinner.show("refreshLoading");
    setTimeout(() => {
      this.ngOnInit();
      if (this.isUserLoggedIn) //if not login
      {
       this.child.getUserProfile();
      }
      this.child2.getAdsList();
      this.child2.getMarqueeText();
      this.spinner.hide("refreshLoading");
      //Added these
      this.storage.clear('actionType');
      this.storage.clear('actionType1');
      //this.storage.clear('localsmstype');
      this.storage.clear('loccaltype');
      localStorage.removeItem('time');
      //clear storage
    //the above two is to remove all storage
    }, 1000);
  }

  getSMSOperators()
  {
    let headers = new HttpHeaders();
    this.http.get(this.funct.ipaddress + 'user/getsmsOperatorList', { headers: headers })
    .pipe(
      catchError(this.handleError.bind(this))
    )
    .subscribe(
      result => {
       this.storage.store("smsOperators",JSON.stringify(result));
    })
  }
}
